import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.4266 1.2246C19.7552 0.876253 21.2241 0.841589 22.1912 1.80858C22.9372 2.55461 23.0815 3.60711 22.9627 4.60937C22.8422 5.62588 22.4353 6.77745 21.8357 7.97655C20.6317 10.3845 18.5417 13.1944 15.868 15.8682C13.1943 18.5418 10.3843 20.6319 7.97637 21.8359C6.77731 22.4354 5.62565 22.8424 4.60918 22.9629C3.60697 23.0816 2.55438 22.9374 1.8084 22.1914C0.841838 21.2247 0.875608 19.7566 1.22344 18.4287C1.56134 17.139 2.27312 15.6592 3.25273 14.1152C3.08906 13.4368 2.99981 12.7288 2.9998 12C2.9998 7.02954 7.02939 3.00017 11.9998 2.99999C12.7289 2.99999 13.4374 3.08914 14.116 3.25292C15.659 2.27394 17.1374 1.56271 18.4266 1.2246ZM20.7771 3.22265C20.6064 3.05206 20.1056 2.85209 18.9344 3.15917C18.2256 3.34503 17.3902 3.69018 16.4646 4.18847C17.362 4.70293 18.1636 5.36516 18.8328 6.1455C18.7921 6.23158 18.751 6.32081 18.7059 6.41112C17.7112 8.40036 15.8752 10.9117 13.3934 13.3935C10.9115 15.8753 8.40015 17.7114 6.41094 18.706C6.32067 18.7512 6.23135 18.7923 6.14531 18.833C5.36502 18.1638 4.70273 17.3621 4.18828 16.4648C3.68945 17.3909 3.34376 18.2265 3.15801 18.9355C2.85148 20.1058 3.05197 20.6067 3.22246 20.7773C3.34943 20.9043 3.65989 21.0611 4.37383 20.9766C5.07358 20.8936 5.99264 20.5924 7.08184 20.0478C9.25057 18.9635 11.8898 17.0182 14.4539 14.4541C17.018 11.89 18.9633 9.25077 20.0477 7.08202C20.5923 5.99277 20.8934 5.0738 20.9764 4.37401C21.061 3.65996 20.9041 3.34962 20.7771 3.22265ZM8.4998 12C7.67153 12.0002 6.9998 12.6717 6.9998 13.5C6.99981 14.3283 7.67153 14.9998 8.4998 15C9.32823 15 9.9998 14.3284 9.99981 13.5C9.99981 12.6716 9.32823 12 8.4998 12ZM6.9998 8.99999C6.44767 9.00017 5.9998 9.44782 5.9998 9.99999C5.99981 10.5522 6.44767 10.9998 6.9998 11C7.55209 11 7.9998 10.5523 7.9998 9.99999C7.9998 9.44771 7.55209 8.99999 6.9998 8.99999ZM12.4998 5.99999C11.1192 6.00017 9.99981 7.11939 9.99981 8.49999C9.99981 9.88059 11.1192 10.9998 12.4998 11C13.8805 11 14.9998 9.8807 14.9998 8.49999C14.9998 7.11928 13.8805 5.99999 12.4998 5.99999Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.9949 12.1914C20.8944 17.0099 17.0097 20.8945 12.1912 20.9951C13.7645 19.8581 15.3755 18.4817 16.9285 16.9287C18.4816 15.3757 19.8579 13.7647 20.9949 12.1914Z"}}]};

const ForumFilled = Vue.extend<IconProps>({
  name: 'ForumFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'forum-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ForumFilled;
